/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Shot_Changes_DescriptionInputs */



/**
* | output |
* | --- |
* | "Configure settings for snapping events to shot changes" |
*
* @param {Snap_To_Shot_Changes_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_shot_changes_description = /** @type {((inputs?: Snap_To_Shot_Changes_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Shot_Changes_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configurer les paramètres pour aligner les événements sur les changements de plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie die Einstellungen für das Ausrichten von Ereignissen an Aufnahmeänderungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configurare le impostazioni per agganciare gli eventi alle modifiche di ripresa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройте параметры привязки событий к изменениям ракурса съемки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configurar ajustes para ajustar eventos a cambios de toma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("配置捕捉事件以拍摄更改的设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットの変更にイベントをスナップするための設定を構成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तन के अनुसार इवेंट स्नैप करने के लिए सेटिंग्स कॉन्फ़िगर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configure as definições para sincronizar eventos com alterações de disparo.")
	return /** @type {LocalizedString} */ ("Configure settings for snapping events to shot changes")
});